import { createSelector } from 'reselect'
import { DialogSchema } from '@feedyou-ai/feedbot-schema'

import { RootState } from '../../reducers'
import { CommentsState } from './commentsSlice'
import { CommentId } from '../../features/serverComments'
import { dialogsSelector } from '../flow/selectors/dialogsSelector'

export const commentsSliceSelector = (state: RootState): CommentsState => state.comments

export const shouldShowResolvedSelector = (state: RootState) =>
  commentsSliceSelector(state).showResolved

export const editedCommentIdSelector = (state: RootState) =>
  commentsSliceSelector(state).editedCommentId

export const draftCommentsSelector = (state: RootState) =>
  commentsSliceSelector(state).commentDrafts

export const isCommentADraftSelector = (state: RootState, id: CommentId) =>
  Object.values(draftCommentsSelector(state))?.some(comment => comment!.id === id)

export const pendingEditsSelector = (state: RootState) => commentsSliceSelector(state).pendingEdits

export const pendingEditsTextForCommentIdSelector = (state: RootState, id?: CommentId) => {
  return commentsSliceSelector(state).pendingEdits[id!]?.text
}

export const stepIdsSelector = createSelector(
  dialogsSelector,
  (dialogs: DialogSchema[] | {}): Set<string> => {
    const stepIds = new Set<string>()

    Object.values(dialogs).forEach((dialog: DialogSchema) => {
      dialog.steps.forEach(step => {
        stepIds.add(step.id)
      })
    })

    return stepIds
  }
)

export const isCommentSubmittingSelector = (state: RootState): boolean =>
  commentsSliceSelector(state).isCommentSubmitting
